import store from '@/store'
import type { Module } from 'vuex'

import type { IRootState } from '../../types'
import type { IMaterialListType, MixPaibanPlans } from './type'

const materialListStore: Module<IMaterialListType, IRootState> = {
  namespaced: true,
  state: {
    // 开料清单中勾选
    selectedMixPaibanPlans: [],

    // 当次排版数据中由颜色，材质，厚度组成的key， 对应的同等颜色
    colorMap: {},
  },

  mutations: {
    setSelectedMixPaibanPlans(state, payload: MixPaibanPlans[]) {
      state.selectedMixPaibanPlans = store.state.preferencesSetting!.setting
        .enableMixPaiban
        ? payload?.map((item) => {
            return {
              ...item,
              allColors: item.originTexture.concat([item.targetTexture]),
            }
          })
        : []
    },

    setColorMap(state, payload: Record<string, string[]>) {
      state.colorMap = payload
    },
  },
}

export default materialListStore
